import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "breadcrumb-arrow",
  "use": "breadcrumb-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" overflow=\"visible\" preserveAspectRatio=\"none\" viewBox=\"0 0 24 24\" id=\"breadcrumb-arrow\"><path xmlns:default=\"http://www.w3.org/2000/svg\" d=\"m8.59 16.34 4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z\" style=\"fill:#fff\" vector-effect=\"non-scaling-stroke\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol